import type { RootState } from "~/store";
import type { Annotation } from "~/types/annotations";
import type { BridgeElement } from "~/types/bridge";

export const getElementsWithAnnotations = (state: RootState) => {
    const elementsWithAnnotations: any[] = [];
    const elements: BridgeElement[] = state.asset.elements;
    const annotations: Annotation[] = state.annotationsManager.imageAnnotations; // Use the selector
    if (!elements || !annotations) {
        return elementsWithAnnotations;
    }
    console.log("getElementsWithAnnotations", { elements, annotations });
    elements.forEach((element: any) => {
        const annotationsByEntity = annotations.filter((annotation: any) => 
            annotation.entity === element.object_id
        );
        
        if (annotationsByEntity.length > 0) {
            const updatedElement = { ...element, children: annotationsByEntity };
            elementsWithAnnotations.push(updatedElement);
        }
    });
    
    return elementsWithAnnotations;
};
